import { render, staticRenderFns } from "./GroupDetailItem.vue?vue&type=template&id=76fc27d2&scoped=true&"
import script from "./GroupDetailItem.vue?vue&type=script&lang=js&"
export * from "./GroupDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupDetailItem.vue?vue&type=style&index=0&id=76fc27d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fc27d2",
  null
  
)

export default component.exports